import React from 'react';
import Card from './SlideCard';
import Holiday from '../../assets/images/holidaypackage.jpg';
import Holiday2 from '../../assets/images/holidaypackage2.jpg';
import Holiday3 from '../../assets/images/holidaypackage3.jpg';
import Holiday4 from '../../assets/images/holidaypackage4.jpg';
import Holiday5 from '../../assets/images/holidaypackage5.jpg';
// Import css files
// import 'slick-carousel/slick/slick.css';
import '../../../node_modules/slick-carousel/slick/slick.css';
import '../../../node_modules/slick-carousel/slick/slick-theme.css';

const dataTop = [
	{
		url: Holiday,
	},
	{
		url: Holiday2,
	},
	{
		url: Holiday3,
	},
	{
		url: Holiday4,
	},
	{
		url: Holiday5,
	},
	{
		url: Holiday3,
	},
	{
		url: Holiday2,
	},
	{
		url: Holiday5,
	},
	{
		url: Holiday,
	},
];

const SimpleSlider = ({ value }) => {
	return (
		<>
			<Card title='Trending' data={dataTop} value={value} />
		</>
	);
};

export default SimpleSlider;
